// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq-content {
  padding-top: 2em;
  padding-bottom: 3em;
  margin-bottom: 1em;
  background-color: #f0f0f0;
}

.card-faq {
  box-shadow: none !important;
  margin-bottom: 4px;
}

.card-faq-question {
  font-size: 1.3em !important;
  font-weight: lighter;
}

.card-body {
  padding-left: 4% !important;
}

.highlighted-url {
  color: #1f40e6;
}

.accordion-button:not(.collapsed) {
  background-color: white !important;
}
.accordion-button:focus {
  border-color: white !important;
}
`, "",{"version":3,"sources":["webpack://./src/css/Faq.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,8BAA8B;AAChC","sourcesContent":[".faq-content {\n  padding-top: 2em;\n  padding-bottom: 3em;\n  margin-bottom: 1em;\n  background-color: #f0f0f0;\n}\n\n.card-faq {\n  box-shadow: none !important;\n  margin-bottom: 4px;\n}\n\n.card-faq-question {\n  font-size: 1.3em !important;\n  font-weight: lighter;\n}\n\n.card-body {\n  padding-left: 4% !important;\n}\n\n.highlighted-url {\n  color: #1f40e6;\n}\n\n.accordion-button:not(.collapsed) {\n  background-color: white !important;\n}\n.accordion-button:focus {\n  border-color: white !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
